import { useState } from 'react'
import { supabase } from '../supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string|null>(null)
  const [notice, setNotice] = useState<string|null>(null)
  const [loading, setLoading] = useState(false)

  // Sign-in only. Floxir accounts are created by invitation (a Floxir admin sets
  // up the company; owners invite their teammates) — there is no public sign-up.
  async function handleSubmit() {
    setError(null)
    setNotice(null)
    setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  // Forgot password: the backend generates a recovery link and sends it via Resend
  // (our branded sender), NOT Supabase's rate-limited mailer. The endpoint always
  // responds neutrally, so we never reveal whether an account exists. The redirect
  // target (/reset-password) must be in Supabase's auth redirect allowlist.
  async function handleForgot() {
    setError(null)
    setNotice(null)
    if (!email) { setError('Enter your email above, then click “Forgot password”.'); return }
    setLoading(true)
    try {
      await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      setNotice('If that email has an account, a reset link is on its way — check your inbox.')
    } catch {
      setError('Network error — please try again.')
    }
    setLoading(false)
  }

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f0eb'}}>
      <div style={{width:380,background:'#fff',borderRadius:16,padding:36,border:'1px solid #e5e7eb'}}>
        <div style={{marginBottom:28,textAlign:'center'}}>
          <div style={{fontSize:22,fontWeight:700,color:'#c4611a'}}>floxir</div>
          <div style={{fontSize:13,color:'#6b7280',marginTop:3}}>AI Operations Platform</div>
        </div>

        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div>
            <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:5}}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e=>setEmail(e.target.value)}
              onKeyDown={e=>e.key==='Enter'&&handleSubmit()}
              style={{width:'100%',padding:'9px 12px',fontSize:14,border:'1px solid #e5e7eb',borderRadius:8,outline:'none'}}
            />
          </div>
          <div>
            <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:5}}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e=>setPassword(e.target.value)}
              onKeyDown={e=>e.key==='Enter'&&handleSubmit()}
              style={{width:'100%',padding:'9px 12px',fontSize:14,border:'1px solid #e5e7eb',borderRadius:8,outline:'none'}}
            />
          </div>

          {error && (
            <div style={{fontSize:12,color:'#dc2626',background:'rgba(220,38,38,.08)',padding:'8px 12px',borderRadius:8}}>
              {error}
            </div>
          )}

          {notice && (
            <div style={{fontSize:12,color:'#3B6D11',background:'rgba(90,138,46,.10)',padding:'8px 12px',borderRadius:8}}>
              {notice}
            </div>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{width:'100%',padding:'10px',fontSize:14,fontWeight:600,color:'#fff',background:'#c4611a',border:'none',borderRadius:8,cursor:'pointer',marginTop:4}}
          >
            {loading ? 'Please wait...' : 'Sign in'}
          </button>

          <button
            type="button"
            onClick={handleForgot}
            disabled={loading}
            style={{background:'none',border:'none',padding:0,fontSize:12,color:'#c4611a',fontWeight:600,cursor:'pointer',textAlign:'center',marginTop:2}}
          >
            Forgot password?
          </button>

          <div style={{fontSize:12,color:'#9A8F82',textAlign:'center',marginTop:6,lineHeight:1.5}}>
            Floxir accounts are set up by invitation. If you were invited, use the
            link in your email to set a password.
          </div>
        </div>
      </div>
    </div>
  )
}
